import { lazy } from "react";

const categoryRoutes = [
        // Chat
        { path: '/chat/chat', component: lazy(() => import('../../views/chat')) },

];

export default categoryRoutes